import { getUrlParam } from "@Engage.Core";
export class UrlParamQualifier {
    constructor(paramNames = []) {
        this.key = "UrlParam";
        this.paramNames = [];
        this.paramNames = paramNames;
    }
    process() {
        return this.paramNames.map((name) => {
            var _a;
            return ({
                key: name,
                value: (_a = getUrlParam(name)) !== null && _a !== void 0 ? _a : null
            });
        });
    }
}
